<template>
    <div>
        <video id="myvideoplayer"
               ref="videoPlayer"
               class="video-js"
               @setloopreq="setloop($event)"
               @clearloopreq="clearloop()"
               @loadeddata="canPlay($event)"
               @playing="$emit('playing',$event),getImages()"
               @pause="$emit('pause',true)"
               @seeked="$emit('seeked')"
               @timeupdate=""
               @progressbar.mousemove="Test($event)"
        ></video>
        <SlideBar
                v-if="player&&Location && $store.state.dev && 1===3"
                :location="player.currentTime()"
                :duration="Duration"
                :poster="poster"
                @location="player.pause(), player.currentTime($event)"
        />
    </div>
</template>

<script>
  import videojs from 'video.js';
  import abLoopPlugin from 'videojs-abloop'
  import vttThumbnails from 'videojs-vtt-thumbnails'
  import SlideBar from "@/views/video/breakdown/SlideBar";

  abLoopPlugin(window, videojs);
  export default {
    name: "VideoJsPlayer",
    components: {SlideBar},
    props: ['src', 'poster', 'controlBar'],
    vp: '#myvideoplayer',
    data() {
      return {
        player: null,
        start: null,
        end: null,
        videoloop: false,
        endloop: null,
        videourl: 'https://videos.athleteforlife.org/',
        duration: 0
      }
    },
    computed: {
      options() {
        return {
          timetooltip: undefined,
          playsinline: true,
          autoplay: false,
          muted: true,
          fluid: true,
          language: 'en',
          playbackRates: [.25, .5, 1, 2],
          controls: true,
          aspectRatio: '16:9',
          inactivityTimeout: 3 * 60 * 1000, // 3 minutes
          controlBar: {
            fullscreenToggle: false,
            progressControls: {
              seekBar: false,
              handleMouseMove: function (e) {
                console.log(e)
              }
            }
          },
          sources: [{
            type: "video/mp4",
            src: this.src,
          }],
          poster: this.poster,
          plugins: {
            // vttThumbnails:{
            //     src: 'img.vtt'
            // },
            abLoopPlugin: {
              'start': this.start,
              'end': this.end,
              "enabled": true,
              "loopIfBeforeStart": true,
              "loopIfAfterEnd": false,
              "pauseBeforeLooping": false,
              "pauseAfterLooping": false,
              "createButtons": !this.readonly
            }
          },
          userActions: {
            doubleClick: function () {
              return
            }
          },
          images:[]
        }
      },
      Location: {
        get() {
          return this.player.currentTime()
        },
        set(val) {
          val = parseFloat(val)
          this.player.currentTime(val)
        }
      },
      PlaybackRate: {
        get() {
          return this.player.playbackRate()
        },
        set(val) {
          this.player.playbackRate(val)
        }
      },
      Duration() {
        return (this.player&&this.player.duration())?this.player.duration():0
      },
    },
    watch:{

    },
    mounted() {
      let em = this;
      let p = em.poster.replace('00001.jpg', '')
      this.player = videojs(
        this.$refs.videoPlayer,
        this.options,
        function onPlayerReady() {
          em.getImages()
          em.timetooltip = this.controlBar.progressControl.seekBar
          console.log('onPlayerReady', em.timetooltip);
          em.timetooltip.ready(function(e){
            console.log(e)
          })
          this.play()
          var ttd = document.getElementsByClassName("vjs-time-tooltip")[0] ;
          em.timetooltip.on('mousemove',function(){
            let v = ttd.innerHTML
            let l = v.split(':')
            let index = parseInt(l[0]*60) + parseInt(l[1])
            index = index===0?1:index
            console.log( index  )
            ttd.style.backgroundImage = 'url('+em.images[index].src+')';
            ttd.style.backgroundPosition = 'center'
            ttd.style.backgroundSize = 'cover'
          })
          em.timetooltip = document.getElementsByClassName('vjs-time-tooltip')[0]
          em.timetooltip.style.top='-100px'
          em.timetooltip.style.width='150px'
          em.timetooltip.style.height='100px'
          let v = em.timetooltip.text
          console.log(v)
        })

      // this.player.mobileUi({
      //   fullscreen: {
      //     enterOnRotate: true,
      //     lockOnRotate: true
      //   },
      //   touchControls: {
      //     seekSeconds: 10,
      //     tapTimeout: 300,
      //     disableOnEnd: false
      //   }
      // });

      this.player.controlBar.progressControl.on('mouseup', function () {
        em.UserSeeked()
      })
      this.player.controlBar.playbackRateMenuButton.on('mouseenter', function () {
        em.$emit('playbackrateactive', true)
      })
      this.player.controlBar.playbackRateMenuButton.on('mouseleave', function () {
        em.$emit('playbackrateactive', false)
      })
      this.getImages()
    },
    methods: {
      getImages() {
        //load sprites or smaller images.. just for efficiency
        let d = parseInt(this.Duration)
        let ar = [];
        for (let index = 1; index <= d-1; index++) {
          console.log(index)
          let c = document.createElement('canvas')
          let ctx = c.getContext('2d')
          c.width=150
          c.height=100
          let p = this.poster.replace('00001.jpg', '')
          let m = new Image(150, 100)
          m.src = p + index.toString().padStart(5,'0') + '.jpg'
          ar.push(m)
        }
        this.images = ar
        console.log('images', this.images.length, this.poster)
      },
      Test(event) {
        console.log(event)
      },
      setLoop(start, end, src) {
        this.player.abLoopPlugin.applyUrl(src)
        this.player.abLoopPlugin.setStart(start)
        this.player.abLoopPlugin.setEnd(end).goToStart().playLoop()
      },
      createModal() {
        var modal = this.player.createModal('This is a modal!');

        // When the modal closes, resume playback.
        let em = this;
        modal.on('modalclose', function () {
          em.player.play();
        });
      },
      Event(e, l) {
        console.log(l, e)
      },
      canPlay() {
        this.player.play()
        this.$emit('canplay')
      },
      Play() {
        this.player.play()
      },
      Pause() {
        this.player.pause();
      },
      Seek(t) {
        var ta = this.player.currentTime();
        var tb = ta + t;
        if (tb < 0) {
          tb = 0
        }
        this.player.currentTime(tb);
      },
      EmitSeeked(e) {
        //console.log('Seeked',e)
      },
      UserSeeked() {
        this.$emit('userseeked', this.Location)
      },
      ShowControls() { //DO NOT USE! DEPRECATING
        this.player.controlBar.show()
      },
      Controls(b) {
        //b = true/false
        this.player.controls(b)
      },
      DoubleClickHandler(e) {
        return
      },
      setPlayBackRate(val) {
        this.player.PlaybackRate = val
      }
    },
    beforeDestroy() {
      if (this.player) {
        this.player.dispose()
      }
    }
  }
</script>

